import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export var SignupCardCta = function SignupCardCta(_ref) {
  var copy = _ref.copy,
      formId = _ref.formId,
      isDisabled = _ref.isDisabled,
      isSubmitting = _ref.isSubmitting;
  return React.createElement("button", {
    className: classNames({
      'bt bt--primary bt--lg bt--width-full': true,
      'bt--waiting': isSubmitting
    }),
    type: "submit",
    disabled: isSubmitting || isDisabled,
    form: formId
  }, copy || React.createElement(FormattedMessage, {
    id: "signup-card.general.action",
    defaultMessage: "Continue"
  }));
};
SignupCardCta.propTypes = {
  copy: PropTypes.node,
  formId: PropTypes.string,
  isDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool
};